import { post } from "../../helpers/api";

const defaultTotals = () => ({
  total_loss_dinar: 0,
  total_loss_dollar: 0,
  total_gain_dinar: 0,
  total_gain_dollar: 0,
  total_loss_count: 0,
  total_gain_count: 0,
});

const state = {
  items: { data: [], current_page: 1, last_page: 1, total: 0, per_page: 25 },
  allItems: [],
  totals: defaultTotals(),
  isLoadingData: true,
  isLoadingTotals: false,
};

const mutations = {
  SET_ITEMS(state, items) {
    state.items = items || state.items;
    state.isLoadingData = false;
  },
  SET_ALL_ITEMS(state, items) {
    state.allItems = Array.isArray(items) ? items : [];
  },
  SET_TOTALS(state, totals) {
    state.totals = { ...defaultTotals(), ...(totals || {}) };
    state.isLoadingTotals = false;
  },
  SET_IS_LOADING_DATA(state, value) {
    state.isLoadingData = value;
  },
  SET_IS_LOADING_TOTALS(state, value) {
    state.isLoadingTotals = value;
  },
};

const actions = {
  // Paginated list — payload accepts: page, rowsPerPage, search, sortBy,
  // sortType, startDate, endDate, dd_type, cu_id, su_id, cur_id, bo_id.
  async getItems({ commit }, payload = {}) {
    commit("SET_IS_LOADING_DATA", true);
    try {
      const page = payload.page || 1;
      const response = await post(
        "debt-discount/index?page=" + page,
        payload,
        { id: 26, action: "view" } // reports group permission
      );
      commit("SET_ITEMS", response.data);
      return response;
    } catch (error) {
      console.log(error);
      commit("SET_IS_LOADING_DATA", false);
      if (error?.response?.status === 408) {
        window.location.href = "/404";
      }
      return error;
    }
  },

  async getTotals({ commit }, payload = {}) {
    commit("SET_IS_LOADING_TOTALS", true);
    try {
      const response = await post(
        "debt-discount/totals",
        payload,
        { id: 26, action: "view" }
      );
      commit("SET_TOTALS", response.data);
      return response;
    } catch (error) {
      console.log(error);
      commit("SET_IS_LOADING_TOTALS", false);
      return error;
    }
  },

  async getAll({ commit }, payload = {}) {
    try {
      const response = await post(
        "debt-discount/all",
        payload,
        { id: 26, action: "view" }
      );
      commit("SET_ALL_ITEMS", response.data);
      return response;
    } catch (error) {
      console.log(error);
      return error;
    }
  },
};

const getters = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
